import { render, staticRenderFns } from "./CoachReviews.vue?vue&type=template&id=4edc628a&scoped=true&lang=pug"
import script from "./CoachReviews.vue?vue&type=script&lang=js"
export * from "./CoachReviews.vue?vue&type=script&lang=js"
import style0 from "./CoachReviews.vue?vue&type=style&index=0&id=4edc628a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edc628a",
  null
  
)

export default component.exports